import styles from './style.postcss';
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Dialog, TextArea, Button, testClass } from 'omni-common-ui';
import is from 'is_js';

class NewNotePopup extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { note: null };
    this._updateNote = this._updateNote.bind(this);
    this._onSaveClicked = this._onSaveClicked.bind(this);
  }

  _updateNote(e) {
    this.setState({ note: e.target.value });
  }

  _onSaveClicked() {
    this.props.onSave(this.state.note);
  }

  _isNoteEmpty() {
    if (is.not.string(this.state.note)) {
      return true;
    }

    return is.empty(this.state.note.trim());
  }

  render() {
    return <Dialog isOpen paddingless className={styles.NewNotePopup}>
      <div className={styles.NewNotePopup_titleBar}>
        <h1 className={styles.NewNotePopup_title}>
          <span>New Note </span>
          <span className={styles.NewNotePopup_title_group}>({this.props.titleGroup})</span>
        </h1>
      </div>
      <div className={classnames(styles.NewNotePopup_content, testClass('new-note-content'))}>
        <div className={styles.NewNotePopup_info}>
          <span>{this.props.studentName}</span>
          {
            this.props.extraInfo &&
            <span>
              <span> | </span>
              <span>{this.props.extraInfo}</span>
            </span>
          }
        </div>
        {
          this.props.category &&
          <div className={styles.NewNotePopup_category}>{this.props.category}</div>
        }
        <TextArea value={this.state.note} onChange={this._updateNote} maxLength={1000} />
        <Button.Container className={styles.NewNotePopup_buttons}>
          <Button className={testClass('button-save')}
              type={Button.Type.primary}
              onClick={this._onSaveClicked}
              disabled={this._isNoteEmpty()}>
            Save & Notify
          </Button>
          <Button className={testClass('button-cancel')}
              onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Button.Container>
      </div>
    </Dialog>;
  }
}

NewNotePopup.propTypes = {
  titleGroup: PropTypes.string.isRequired,
  studentName: PropTypes.string.isRequired,
  extraInfo: PropTypes.string,
  category: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default NewNotePopup;



// WEBPACK FOOTER //
// ./components/NewNotePopup/index.jsx